import { atom } from "jotai";
import { atomWithStorage } from "jotai/utils";
import { makeSessionJsonStorage, withPrefix } from "./storage";

// no cross-tab sync to avoid flicker
export const selectedTpidAtom = atomWithStorage<number | null>(
  withPrefix("selected-tpid"),
  null,
  makeSessionJsonStorage<number | null>()
);

// (Optional) advanced mode atom if you want to toggle logic in UI
export const advancedModeAtom = atom<boolean>(false);

export const currentTpidKeyAtom = atom((get) => {
  const override = get(selectedTpidAtom); // number|null
  return override == null ? "auto" : String(override);
});
